<template>
    <form :action="action" :method="method" ref="form">
        <slot name="content" :onChange="onChange">

        </slot>
    </form>
</template>

<script>

    import mixinPubSub from '../mixinPubSub';
    export default {
        mixins: [ mixinPubSub ],
        props: {
            action: {
                type: String,
                default: '',
            },
            method: {
                type: String,
                default: 'get',
            }
        },
        data() {
            return {
                loading: false,
            }
        },
        watch: {
            loading: function( loading ) {
                this.triggerPageLoading( loading );

                if( this.response && this.response.status ) {
                    return;
                }

                this.disableSubmit = loading;
            }
        },
        methods: {
            onChange() {
                this.loading = true;
                this.$refs.form.submit();
            }
        }
    }
</script>
